export enum AppActionTypes {
  INCREMENT_INTERSTITIAL = 'INCREMENT_INTERSTITIAL',
  RESET_INTERSTITIAL = 'RESET_INTERSTITIAL',
  DEFINE_PRODUCT = 'DEFINE_PRODUCT',
  DEFINE_OPEN_BAR = 'DEFINE_OPEN_BAR'
}

export enum ListProjetsActionType {
  CODE_PUSH_INITIAL_PROJECTS = 'CODE_PUSH_INITIAL_PROJECTS',
  REMOVE_NEW_FLAG_PROJECTS = 'REMOVE_NEW_FLAG_PROJECTS'
}

export enum ProjectsActiontypes {
  DEFINE_PROJECT = 'ProjectsActiontypes/DEFINE_PROJECT',
  DEFINE_PROJECTSECTION = 'ProjectsActiontypes/DEFINE_PROJECTSECTION',
  RESET_PROJECT = 'ProjectsActiontypes/RESET_PROJECT',
  DO_CALCUL_PROJECT = 'ProjectsActiontypes/DO_CALCUL_PROJECT',
  UPDATE_CONTEXT_PROJECT = 'ProjectsActiontypes/UPDATE_CONTEXT_PROJECT',
  UPDATE_CONTEXT_PROJECT_VALUE = 'ProjectsActiontypes/UPDATE_CONTEXT_PROJECT_VALUE',
  LOAD_CONTEXT_PROJECT = 'ProjectsActiontypes/LOAD_CONTEXT_PROJECT'
}
